// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------search--------------------*/

.s57vVVN9DvbMuoxvp2Iw {
  border-radius: 20px;
  border: 0px;
  background: rgba(var(--tertiary-bg-dark), 0.3);
  color: rgb(var(--placeholder-primary-dark));
  padding: 16px 45px 16px 50px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
}

.r6k3ru3SKPW5bhkgvYQV {
  position: relative;
  margin-bottom: 8px;
}

.KeZCcttjXijPkXCvGTTB {
  position: absolute;
  left: 17px;
  top: 50%;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
  > path {
    stroke: #98989E;
  }
}

.isnDHnaw7GlVb1Nb1PGW {
  position: absolute;
  right: 20px;
  top: 52%;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  cursor: pointer;
}

/*--------------------/search--------------------*/

.XMMcSnoUnXLt7RhWJZ0W {
  font-size: 15px;
  line-height: 138%;
  letter-spacing: 0.07px;
  color: #8E8E93;
}

.l5CTsOVeAx2ZIMYIilMZ {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  outline: none;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.l5CTsOVeAx2ZIMYIilMZ > div {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/*--------------------token--------------------*/

.qwFlgaBjpoc4nDKvyzqj {
  height: calc(100% - 20px);
  padding: 16px;
  background: rgba(var(--secondary-bg), 0.40);
  border-radius: 24px 24px 0 0;
}

.loR6PSbaM9eArRUEyCUY {
  max-height: 100%;
  overflow-y: auto;
  padding-bottom: 72px;
}
  

.iLNraJxvO49VFuV8zgz6 {
  padding: 8px 10px 8px 10px;
  margin-bottom: 8px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: relative;
  width: 100%;
  cursor: pointer;
  transition: background 0.3s ease 0s;
}

.iLNraJxvO49VFuV8zgz6:active {
  background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .tokenItem:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

.iLNraJxvO49VFuV8zgz6::before {
  content: '';
  position: absolute;
  width: calc(100%);
  height: 0.1px;
  bottom: -4px;
  right: 0;
  background: rgba(var(--tertiary-bg-dark), 1);
}

.dWcv5hEkjX3gdavSYosV {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
}

._ShQAbOmcXl4WxI0yWPo {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 5px;
}
.yNrC0GRX0F1AuCqqJ_Nc {
  color: #34C759 !important;
}
.UFk1FBsOkaySA40BYmF9 {
  color: #FF3B30 !important;
}

._6cQQW9PrHi44OHlhRRs {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc(100% - 60px);
  padding-right: 10px;
}

.o_TqKbfzks6nZYTO7fD_ {
  display: flex;
  flex-direction: column;
}

.dWcv5hEkjX3gdavSYosV > img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.T1Epylffi969ttsE7hOG {
  font-size: 17px;
  line-height: 129%;
  letter-spacing: 0.43px;
  color: rgb(var(--placeholder-primary));
}

.ep9rD7iK580F4IFx8zy9 {
  color: rgb(var(--placeholder-primary));
  text-align: right;
}

.AbPTVwfVtDA6Tx8ksHiI {
  color: rgb(var(--placeholder-secondary));
  font-size: 13px;
  line-height: 19.5px;
}
.a_15X0HUI838gT2vicRZ {
  color: #8E8E93;
  font-size: 11px;
  line-height: 19.5px;
}

/*--------------------/token--------------------*/

.M02w9eIgpdwF5LsklAJd {
  height: 30vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
  text-align: center;
  font-size: 21px;
  font-weight: 540;
}

/* ------------- */
.J167feXkVehxRv3d3S9a {
display: grid;
grid-template-columns: 0.5fr 2fr 0.5fr;
align-items: center;
gap: 5px;
margin-bottom: 24px;
}

.rin2EFCt3UvhCjyfnkxo {
color: rgb(var(--accent-brand-dark));
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 22px; /* 122.222% */
letter-spacing: -0.5px;
padding: 0;
background: transparent;
cursor: pointer;
border: none;
justify-content: flex-start;
}

.tUHFClTC_Kn2STITUkot {
text-align: center;
font-size: 32px;
font-style: normal;
font-weight: 510;
line-height: 32px; /* 100% */
letter-spacing: -0.264px;
color: rgb(var(--placeholder-primary));
margin-bottom: 24px;
}

.NHY0080_K7HDT8sZvldA {
position: relative;
z-index: 301;
  overflow-x: hidden;
}

.gyUirlwqQ87j9GUa90rr {
height: 95%;
overflow-y: hidden;
background: rgb(var(--primary-bg));
z-index: 301;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/pages/main/buy-modal/select-token/select-token.module.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;EAC9C,2CAA2C;EAC3C,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,kDAAkD;;AAElD;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gDAAgD;;AAEhD;EACE,yBAAyB;EACzB,aAAa;EACb,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;;AAGA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,iDAAiD;;AAEjD;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;AACA,aAAa;AACb,sCAAsC;AACtC,mBAAmB;AACnB,QAAQ;AACR,mBAAmB;AACnB;;AAEA;AACA,oCAAoC;AACpC,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC,sBAAsB;AACtB,UAAU;AACV,uBAAuB;AACvB,eAAe;AACf,YAAY;AACZ,2BAA2B;AAC3B;;AAEA;AACA,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;AAC5B,wBAAwB;AACxB,sCAAsC;AACtC,mBAAmB;AACnB;;AAEA;AACA,kBAAkB;AAClB,YAAY;EACV,kBAAkB;AACpB;;AAEA;AACA,WAAW;AACX,kBAAkB;AAClB,kCAAkC;AAClC,YAAY;EACV,kBAAkB;AACpB","sourcesContent":["/*--------------------search--------------------*/\n\n.search {\n  border-radius: 20px;\n  border: 0px;\n  background: rgba(var(--tertiary-bg-dark), 0.3);\n  color: rgb(var(--placeholder-primary-dark));\n  padding: 16px 45px 16px 50px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 125% */\n  letter-spacing: -0.5px;\n}\n\n.searchInner {\n  position: relative;\n  margin-bottom: 8px;\n}\n\n.searchIcon {\n  position: absolute;\n  left: 17px;\n  top: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translateY(-50%);\n  > path {\n    stroke: #98989E;\n  }\n}\n\n.scan {\n  position: absolute;\n  right: 20px;\n  top: 52%;\n  width: 20px;\n  height: 20px;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n/*--------------------/search--------------------*/\n\n.assetsTitle {\n  font-size: 15px;\n  line-height: 138%;\n  letter-spacing: 0.07px;\n  color: #8E8E93;\n}\n\n.searchClear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  outline: none;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.searchClear > div {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/*--------------------token--------------------*/\n\n.seleсtWrapper {\n  height: calc(100% - 20px);\n  padding: 16px;\n  background: rgba(var(--secondary-bg), 0.40);\n  border-radius: 24px 24px 0 0;\n}\n\n.tokensList {\n  max-height: 100%;\n  overflow-y: auto;\n  padding-bottom: 72px;\n}\n  \n\n.tokenItem {\n  padding: 8px 10px 8px 10px;\n  margin-bottom: 8px;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  position: relative;\n  width: 100%;\n  cursor: pointer;\n  transition: background 0.3s ease 0s;\n}\n\n.tokenItem:active {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .tokenItem:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n.tokenItem::before {\n  content: '';\n  position: absolute;\n  width: calc(100%);\n  height: 0.1px;\n  bottom: -4px;\n  right: 0;\n  background: rgba(var(--tertiary-bg-dark), 1);\n}\n\n.tokenItemBody {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.usdPriseWrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  gap: 5px;\n}\n.upChange {\n  color: #34C759 !important;\n}\n.downChange {\n  color: #FF3B30 !important;\n}\n\n.tokenItemInner {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: calc(100% - 60px);\n  padding-right: 10px;\n}\n\n.tokenColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.tokenItemBody > img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.tokenItemToken {\n  font-size: 17px;\n  line-height: 129%;\n  letter-spacing: 0.43px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.tokenItemAmountRight {\n  color: rgb(var(--placeholder-primary));\n  text-align: right;\n}\n\n.tokenItemPrice {\n  color: rgb(var(--placeholder-secondary));\n  font-size: 13px;\n  line-height: 19.5px;\n}\n.tokenItemPriceChange {\n  color: #8E8E93;\n  font-size: 11px;\n  line-height: 19.5px;\n}\n\n/*--------------------/token--------------------*/\n\n.noAssets {\n  height: 30vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -20px;\n  text-align: center;\n  font-size: 21px;\n  font-weight: 540;\n}\n\n/* ------------- */\n.modalTop {\ndisplay: grid;\ngrid-template-columns: 0.5fr 2fr 0.5fr;\nalign-items: center;\ngap: 5px;\nmargin-bottom: 24px;\n}\n\n.modalTopButton {\ncolor: rgb(var(--accent-brand-dark));\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 22px; /* 122.222% */\nletter-spacing: -0.5px;\npadding: 0;\nbackground: transparent;\ncursor: pointer;\nborder: none;\njustify-content: flex-start;\n}\n\n.modalTitle {\ntext-align: center;\nfont-size: 32px;\nfont-style: normal;\nfont-weight: 510;\nline-height: 32px; /* 100% */\nletter-spacing: -0.264px;\ncolor: rgb(var(--placeholder-primary));\nmargin-bottom: 24px;\n}\n\n.wrapper {\nposition: relative;\nz-index: 301;\n  overflow-x: hidden;\n}\n\n.modal {\nheight: 95%;\noverflow-y: hidden;\nbackground: rgb(var(--primary-bg));\nz-index: 301;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `s57vVVN9DvbMuoxvp2Iw`,
	"searchInner": `r6k3ru3SKPW5bhkgvYQV`,
	"searchIcon": `KeZCcttjXijPkXCvGTTB`,
	"scan": `isnDHnaw7GlVb1Nb1PGW`,
	"assetsTitle": `XMMcSnoUnXLt7RhWJZ0W`,
	"searchClear": `l5CTsOVeAx2ZIMYIilMZ`,
	"seleсtWrapper": `qwFlgaBjpoc4nDKvyzqj`,
	"tokensList": `loR6PSbaM9eArRUEyCUY`,
	"tokenItem": `iLNraJxvO49VFuV8zgz6`,
	"tokenItemBody": `dWcv5hEkjX3gdavSYosV`,
	"usdPriseWrapper": `_ShQAbOmcXl4WxI0yWPo`,
	"upChange": `yNrC0GRX0F1AuCqqJ_Nc`,
	"downChange": `UFk1FBsOkaySA40BYmF9`,
	"tokenItemInner": `_6cQQW9PrHi44OHlhRRs`,
	"tokenColumn": `o_TqKbfzks6nZYTO7fD_`,
	"tokenItemToken": `T1Epylffi969ttsE7hOG`,
	"tokenItemAmountRight": `ep9rD7iK580F4IFx8zy9`,
	"tokenItemPrice": `AbPTVwfVtDA6Tx8ksHiI`,
	"tokenItemPriceChange": `a_15X0HUI838gT2vicRZ`,
	"noAssets": `M02w9eIgpdwF5LsklAJd`,
	"modalTop": `J167feXkVehxRv3d3S9a`,
	"modalTopButton": `rin2EFCt3UvhCjyfnkxo`,
	"modalTitle": `tUHFClTC_Kn2STITUkot`,
	"wrapper": `NHY0080_K7HDT8sZvldA`,
	"modal": `gyUirlwqQ87j9GUa90rr`
};
export default ___CSS_LOADER_EXPORT___;
